import { Avatar, Checkbox, Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { TabNativeContent } from '../common/Tab';
import { showProgress } from '../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../constants/apiEndpoints';
import service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import ImageAvatar from '../common/Avatar';
import ZeroState from '../common/ZeroState';
import FileSeachIcon from '../../assets/FileSearchIcon';

const useStyle = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  searchInput: {
    width: '90%',
    padding: '10px',
    background: '#fff',
    borderRadius: '10px',
  },
  wrapper: {
    width: '92%',
    height: '43vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  role: {
    background: '#fff',
    padding: '10px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  disabledRole: {
    background: '#ffffff',
    padding: '10px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    padding: '2px',
  },
  disabledTitleBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    padding: '2px',
    opacity: '0.4',
  },
  recipients: {
    width: '95%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '20px',
    marginTop: '10px',
  },
  recipient: {
    width: '47%',
    height: '80px',
    border: '1px solid #E4E7EC',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#10182B',
  },
  assignedEmp: {
    width: '47%',
    height: '80px',
    border: '1px solid #E4E7EC',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    opacity: '0.4',
  },
  profilePic: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    overflow: 'hidden',
  },
});

export default function RecipientList({
  type,
  slectedJId,
  roles,
  setRoles,
  selectedEmpUnderRole,
  setSelectedEmpUnderRole,
  setSelectedRoleEmp,
  dealershipId,
  callFrom,
}) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const delaershipHeader = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const [searchVal, setSearchVal] = useState('');
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [openedRoles, setOpenedRoles] = useState([]);
  const [filteredEmpList, setFilteredEmpList] = useState([]);
  const [apiResponse, setApiResponse] = useState({});
  const [dealerId, setDealerId] = useState(null);

  useState(() => {
    if (callFrom === 'px') {
      setDealerId(dealershipId);
    } else {
      setDealerId(delaershipHeader.id);
    }
  }, [delaershipHeader]);

  const handleSearch = (e) => {
    const searchKey = e.target.value;
    setSearchVal(searchKey);
    const filteredEmp = employeeList.map((department) => {
      const filteredRoles = department.roles.map((role) => {
        const filteredEmployees = role.employees.filter((employee) =>
          employee.name.toLowerCase().includes(searchKey.toLowerCase()),
        );

        if (filteredEmployees.length > 0) {
          setOpenedRoles((prevRoles) => [...prevRoles, role.id]);
        }

        return {
          ...role,
          employees: filteredEmployees,
        };
      });
      return {
        ...department,
        roles: filteredRoles,
      };
    });

    setFilteredEmpList(filteredEmp);
  };

  useEffect(() => {
    setFilteredEmpList(employeeList);
  }, [employeeList]);

  const getCount = (index) => {
    const dep = filteredEmpList && filteredEmpList[index];
    const roleList = dep ? dep.roles : [];

    const count = roleList.reduce((accumulator, role) => {
      const empCount = role.employees?.length || 0;
      return accumulator + empCount;
    }, 0);

    return count;
  };

  const RECIPIENT_TABS = [
    { label: `Sales (${getCount(0)})`, index: 0 },
    { label: `Service and Parts  (${getCount(1)})`, index: 1 },
    { label: `F&I (${getCount(2)})`, index: 2 },
    { label: `Lead. & Corp. (${getCount(3)})`, index: 3 },
  ];
  const getRecipients = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(
        apiEndpoints.DEALER_RESIPIENT_LIST.replace('DEALER_ID', dealerId).replace('JOURNEY_ID', slectedJId),
      );
      setApiResponse(res);
      transformData(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const transformData = (originalData) => {
    const transformedData = [];

    originalData.departments.forEach((department) => {
      const departmentName = department.title;
      const departmentId = department.id;
      const isNotAllowed = department.notAllowed;
      const departmentData = {
        department: departmentName,
        id: departmentId,
        isNotAllowed,
        roles: [],
      };

      originalData.departmentRoles[department.id].forEach((role) => {
        const roleName = role.title;
        const roleId = role.id;
        const isAssigned = role.assigned;
        const isRoleAllowed = role.notAllowed;
        const roleData = {
          role: roleName,
          id: roleId,
          isNotAllowed: isRoleAllowed,
          assigned: type === 'assign' ? isAssigned : false,
          employees: originalData.employees[role.id]
            .filter((employee) => !employee.notAllowed)
            .map((employee) => ({
              id: employee.id,
              hash: employee.hash,
              profilePic: employee.profilePic,
              departmentRoleId: employee.departmentRoleId,
              name: employee.name,
              roleName: employee.roleName,
              assigned: type === 'assign' ? employee.assigned : false,
            })),
        };

        departmentData.roles.push(roleData);
      });

      transformedData.push(departmentData);
    });

    setEmployeeList(transformedData);
  };

  useEffect(() => {
    if (dealerId) {
      getRecipients();
    }
  }, [dealerId]);

  const onCheck = (hash, data, setData) => {
    const temp = [...data];
    if (temp.includes(hash)) {
      const indexToRemove = temp.indexOf(hash);
      temp.splice(indexToRemove, 1);
    } else {
      temp.push(hash);
    }
    setData(temp);
  };

  useEffect(() => {
    const dep = filteredEmpList[selectedTabIndex];
    const roleList = dep?.roles;
    if (roleList && roleList.length > 0 && !searchVal) {
      setOpenedRoles([roleList[0].id]);
    }
  }, [filteredEmpList, selectedTabIndex]);

  const checkAllEmp = (e, role) => {
    const isChecked = e.target.checked;
    const preRoles = [...roles];
    const temp = { ...selectedEmpUnderRole };
    const unAssignedEmps = role.employees.filter((emp) => !emp.assigned) || [];
    const empHashList = unAssignedEmps?.map((emp) => emp.hash);
    const isAllCheck = unAssignedEmps.length === (temp[role.id]?.length || 0);
    if (isChecked && !isAllCheck) {
      preRoles.push(role.id);
      temp[role.id] = empHashList;
    } else {
      temp[role.id] = [];
      const index = preRoles.indexOf(role.id);
      preRoles.splice(index, 1);
    }
    setSelectedEmpUnderRole(temp);
    setRoles(preRoles);
  };

  const handleAddEmp = (e, role, hash) => {
    const roleId = role.id;
    const isChecked = e.target.checked;
    const temp = { ...selectedEmpUnderRole };
    const assignedEmps = role.employees.filter((emp) => emp.assigned) || [];
    const preRoles = [...roles];
    const selectedRole = employeeList[selectedTabIndex].roles?.find((item) => item.id === role.id) || {};
    if (isChecked) {
      temp[roleId] = temp[roleId] ? [...temp[roleId], hash] : [hash];
      if (assignedEmps.length + temp[roleId].length === selectedRole?.employees?.length) {
        temp[roleId] = [];
        preRoles.push(roleId);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (preRoles.includes(roleId)) {
        const index = preRoles.indexOf(roleId);
        preRoles.splice(index, 1);
        const empHashList = role.employees.filter((emp) => !emp.assigned && emp.hash !== hash).map((emp) => emp.hash);
        temp[roleId] = empHashList;
      } else if (temp[roleId] && temp[roleId].includes(hash)) {
        temp[roleId] = temp[roleId].filter((empHash) => empHash !== hash);
      }
    }

    setRoles(preRoles);
    setSelectedEmpUnderRole(temp);
  };

  const getCheckedStatus = (role) => roles.includes(role.id);

  const getIndeterminateStatus = (role) =>
    role.id in selectedEmpUnderRole &&
    selectedEmpUnderRole[role.id].length > 0 &&
    selectedEmpUnderRole[role.id].length !==
      (employeeList[selectedTabIndex].roles?.find((item) => item.id === role.id)?.employees || []).length;

  const getColor = (isCheck) => {
    if (searchVal) {
      return '#667085';
    }
    if (isCheck) {
      return '#622fee';
    }
    return null;
  };

  const onSelectAllRoles = (e) => {
    const selectedDep = filteredEmpList[selectedTabIndex];
    let allRoles = [...roles];
    const allEmpsOfRole = { ...selectedEmpUnderRole };
    const isChecked = e.target.checked;
    if (isChecked) {
      selectedDep?.roles?.forEach((r) => {
        if (!r.isNotAllowed && !r.assigned && r.employees?.length > 0) {
          allRoles.push(r.id);
          allEmpsOfRole[r.id] = [];
        }
      });
    } else {
      selectedDep?.roles?.forEach((r) => {
        if (!r.isNotAllowed && !r.assigned && r.employees?.length > 0) {
          const index = allRoles.indexOf(r.id);
          allRoles.splice(index, 1);
          allEmpsOfRole[r.id] = [];
        }
      });
    }
    allRoles = Array.from(new Set(allRoles));
    setRoles(allRoles);
    setSelectedEmpUnderRole(allEmpsOfRole);
  };

  const isAllRoleChecked = () => {
    const selectedDep = filteredEmpList[selectedTabIndex];
    let disabled = 0;
    let checked = 0;

    selectedDep?.roles?.forEach((r) => {
      if (r.assigned || r.isNotAllowed) {
        disabled += 1;
      } else if (roles.includes(r.id)) {
        checked += 1;
      }
    });

    if (disabled + checked === selectedDep?.roles?.length && checked !== 0) {
      return 'checked';
    }
    if (checked > 0) {
      return 'indeterminate';
    }
    return false;
  };

  const isAllCheckDisabled = () => {
    const selectedDep = filteredEmpList[selectedTabIndex];
    let isDisable = false;
    let countNoEmp = 0;
    if (selectedDep?.isNotAllowed || selectedDep?.assigned) {
      isDisable = true;
    }

    selectedDep?.roles?.forEach((r) => {
      if (r.assigned || r.isNotAllowed || r.employees?.length === 0) {
        countNoEmp += 1;
      }
    });

    if (countNoEmp === selectedDep?.roles?.length) {
      isDisable = true;
    }
    return isDisable;
  };

  useEffect(() => {
    if (type === 'share' && !_isEmpty(apiResponse)) {
      let preVal = [];
      roles.forEach((roleId) => {
        const temp = apiResponse?.employees[roleId]?.map((emp) => emp.hash);
        preVal = preVal.concat(temp);
      });
      setSelectedRoleEmp(preVal);
    }
  }, [roles]);

  const getRoleEmpCount = (role) => {
    let count = 0;
    if (roles.includes(role.id)) {
      const temp = role.employees?.filter((emp) => !emp.assigned);
      count = temp.length;
    } else {
      count = selectedEmpUnderRole[role.id]?.length;
    }
    return count;
  };

  return (
    <Grid className={classes.container}>
      <TextField
        placeholder="Search employee"
        className={classes.searchInput}
        value={searchVal}
        onChange={handleSearch}
        InputProps={{ disableUnderline: true }}
      />

      <Grid style={{ background: '#fefefe', width: '55vw', margin: '20px 0px' }}>
        <TabNativeContent
          tabValue={selectedTabIndex}
          setTabValue={setSelectedTabIndex}
          tabs={RECIPIENT_TABS}
          tabWidth="23%"
        />
      </Grid>

      <Grid className={classes.wrapper}>
        {filteredEmpList.length > 0 && filteredEmpList[selectedTabIndex]?.roles?.length > 0 ? (
          <Grid className={classes.role}>
            <Grid className={isAllCheckDisabled() || searchVal ? classes.disabledTitleBox : classes.titleBox}>
              <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <Checkbox
                  onClick={(e) => {
                    if (searchVal) return;
                    const isDisable = isAllCheckDisabled();
                    if (isDisable && type === 'share') {
                      ErrorToast('No access/users available for the selected Roles');
                    } else if (isDisable && type === 'assign') {
                      ErrorToast('Some users may not have access or have already been assigned the journey');
                    } else {
                      onSelectAllRoles(e);
                    }
                  }}
                  indeterminate={
                    isAllRoleChecked() === 'indeterminate' && !filteredEmpList[selectedTabIndex]?.isNotAllowed
                  }
                  checked={isAllRoleChecked() === 'checked' && !filteredEmpList[selectedTabIndex]?.isNotAllowed}
                  style={{
                    color: getColor(
                      (isAllRoleChecked() === 'checked' || isAllRoleChecked() === 'indeterminate') &&
                        !filteredEmpList[selectedTabIndex]?.isNotAllowed,
                    ),
                  }}
                />
                <Typography>Select All</Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : null}

        {filteredEmpList.length > 0 && filteredEmpList[selectedTabIndex]?.roles?.length > 0 ? (
          filteredEmpList[selectedTabIndex].roles?.map((role) => (
            <Grid className={classes.role} key={role.id}>
              <Grid
                className={
                  role.isNotAllowed || role.assigned || role.employees?.length === 0
                    ? classes.disabledTitleBox
                    : classes.titleBox
                }
                onClick={() => onCheck(role.id, openedRoles, setOpenedRoles)}
              >
                <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <Checkbox
                    disabled={searchVal}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (role.isNotAllowed) {
                        ErrorToast(
                          `${role.role} don’t have access to the selected ${type === 'assign' ? 'journey' : 'guide'}.`,
                        );
                      } else if (role.assigned) {
                        ErrorToast(`Journey is currently assigned to the role - ${role.role}.`);
                      } else if (role.employees?.length === 0) {
                        ErrorToast(`No users available in the selected role`);
                      } else {
                        checkAllEmp(e, role);
                      }
                    }}
                    indeterminate={getIndeterminateStatus(role)}
                    checked={getCheckedStatus(role)}
                    style={
                      searchVal
                        ? {
                            ...{ color: getColor(getIndeterminateStatus(role) || getCheckedStatus(role)) },
                            opacity: 0.4,
                          }
                        : {
                            ...{ color: getColor(getIndeterminateStatus(role) || getCheckedStatus(role)) },
                          }
                    }
                  />
                  <Typography>{role.role}</Typography>
                </Grid>

                <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  {getRoleEmpCount(role) || 0}/{role.employees?.length}
                  {openedRoles.includes(role.id) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </Grid>
              </Grid>
              {openedRoles.includes(role.id) && role.employees?.length > 0 && (
                <Grid className={classes.recipients}>
                  {role.employees?.map((emp) => (
                    <Grid
                      className={emp.assigned || role.isNotAllowed ? classes.assignedEmp : classes.recipient}
                      key={emp.id}
                    >
                      <Checkbox
                        onClick={(e) => {
                          if (role.isNotAllowed) {
                            ErrorToast(
                              `${role.role} don’t have access to the selected ${
                                type === 'assign' ? 'journey' : 'guide'
                              }.`,
                            );
                          } else if (emp.assigned) {
                            ErrorToast('Journey is currently assigned to the user.');
                          } else {
                            handleAddEmp(e, role, emp.hash);
                            // onCheck(emp.hash, recipients, setRecipients);
                          }
                        }}
                        checked={
                          selectedEmpUnderRole[role.id]?.includes(emp.hash) ||
                          (roles.includes(role.id) && !emp.assigned)
                        }
                        style={{
                          ...(selectedEmpUnderRole[role.id]?.includes(emp.hash) ||
                          (roles.includes(role.id) && !emp.assigned)
                            ? { color: '#622fee' }
                            : {}),
                        }}
                      />
                      <Grid style={{ width: '60px', height: '60px', borderRadius: '50%', overflow: 'hidden' }}>
                        {emp.profilePic ? (
                          <ImageAvatar
                            src={emp.profilePic}
                            alt="profile"
                            style={{ width: '57px', height: '57px', objectFit: 'cover' }}
                          />
                        ) : (
                          <Avatar style={{ width: '57px', height: '57px' }}>{emp.name[0]?.toUpperCase()}</Avatar>
                        )}
                      </Grid>
                      <Grid>
                        <Typography variant="p">{emp.name}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          ))
        ) : (
          <Grid style={{ width: '90%', margin: '0px auto' }}>
            <ZeroState
              Icon={FileSeachIcon}
              text="No users have access to the selected journey"
              style={{ paddingBottom: '100px' }}
              cardWidth="100%"
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
